import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Flex, Grid } from '@chakra-ui/react';
import React from 'react';
import { Button } from '../../../components/button/button';
import { SearchBar } from '../../../components/search-bar/search-bar';
import { ButtonVariant } from '../../../core/enums';
import { styles } from '../dictionary-styles';
import { getDictionaryValueItems } from './dictionary-value-utils';
import { MenuIcon } from '../../../components/menu-icon/menu-icon';
import { PopUpFiltersV2 } from '../../pop-up-filter/pop-up-filtersV2';
import { RowsPerPage } from '../../../components/rows-per-page/rows-per-page';
import { BreadCrumbsComponent } from '../../../components/breadcrumbs/breadcrumbsComponent';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
const DictionaryValueListHeader = (props)=>{
    const { deleteDisabled, downloadDisabled, handleHistoryClick, handleMetadataClick, handleSearchKeyPress, handleSearchOptionChange, handleSearchInputChange, metadataDisabled, publishDisabled, selectedOption, searchForms, toggleInfoModal, isInfoModalOpen, viewOnly, toggleUploadType, navigate, handleDownload, handleDeleteSelect, toggleSecurityModal, isSecurityModalOpen, criteriaFilter, sortablePageable, setFilterableOptions, isUnrestrictedDictionary, pageSize, onPageSizeChange, togglePublishModal, isPublishModalOpen } = props;
    const classes = styles();
    const handleMenuItemClick = (event)=>{
        const target = event.currentTarget;
        if (target.value === 'History') {
            handleHistoryClick();
        }
        if (target.value === 'Info') {
            handleInfoSelect();
        }
        if (target.value === 'Security') {
            handleSecuritySelect();
        }
        if (target.value === 'Delete') {
            handleDeleteSelect();
        }
        if (target.value === 'Metadata') {
            handleMetadataClick();
        }
        if (target.value === 'Upload New Version') {
            toggleUploadType(false);
            handleUpload();
        }
        if (target.value === 'Make a Correction') {
            toggleUploadType(true);
            handleUpload();
        }
        if (target.value === 'Download') {
            if (!downloadDisabled) {
                handleDownload();
            }
        }
    };
    const handleInfoSelect = ()=>{
        toggleInfoModal(!isInfoModalOpen);
    };
    const handlePublishSelect = ()=>{
        togglePublishModal(!isPublishModalOpen);
    };
    const handleSecuritySelect = ()=>{
        toggleSecurityModal(!isSecurityModalOpen);
    };
    const handleUpload = ()=>{
        if (navigate) {
            navigate(window.location.pathname + `/upload`);
        }
    };
    const handleAddRow = ()=>{
        if (navigate) {
            navigate(window.location.pathname + `/row/add`);
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Grid, {
                display: "flex",
                flexDirection: "row",
                children: [
                    /*#__PURE__*/ _jsx(Flex, {
                        marginBottom: 5,
                        children: /*#__PURE__*/ _jsx(BreadCrumbsComponent, {})
                    }),
                    isUnrestrictedDictionary ? /*#__PURE__*/ _jsx("i", {
                        className: "fas fa-unlock",
                        style: classes.unrestrictedDictionary
                    }) : null,
                    /*#__PURE__*/ _jsxs(Grid, {
                        sx: classes.btnHeader,
                        children: [
                            /*#__PURE__*/ _jsx(PopUpFiltersV2, {
                                loadStates: undefined,
                                criteriaFilter: criteriaFilter,
                                sortablePageable: sortablePageable,
                                getDictionary: ()=>{},
                                getStatuses: ()=>{},
                                list: ()=>{},
                                getTenants: ()=>{},
                                activeOrgId: 0,
                                setFilterableOptions: setFilterableOptions,
                                isUnrestrictedDictionary: isUnrestrictedDictionary
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                label: "Publish",
                                disabled: publishDisabled,
                                variant: ButtonVariant.SECONDARY,
                                name: "Publish",
                                dataTestId: "publish",
                                onClick: handlePublishSelect
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                label: "+ Add Row",
                                variant: ButtonVariant.PRIMARY,
                                name: "AddRow",
                                disabled: viewOnly,
                                dataTestId: "addRow",
                                onClick: handleAddRow
                            }),
                            /*#__PURE__*/ _jsx(MenuIcon, {
                                items: getDictionaryValueItems(deleteDisabled, metadataDisabled, downloadDisabled),
                                dataTestId: "dictionaryValueMenu",
                                icon: /*#__PURE__*/ _jsx(BiomeIcon, {
                                    iconName: IconName.Vertical_Menu,
                                    titleText: "Menu"
                                }),
                                onChange: handleMenuItemClick
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Grid, {
                display: 'flex',
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ _jsx(SearchBar, {
                        selectOptions: searchForms,
                        selectedOption: selectedOption,
                        onSelectOptionChange: handleSearchOptionChange,
                        onSearchInputChange: handleSearchInputChange,
                        onSearchKeyPress: handleSearchKeyPress
                    }),
                    /*#__PURE__*/ _jsx(RowsPerPage, {
                        pageSize: pageSize,
                        handlePageSize: onPageSizeChange
                    })
                ]
            })
        ]
    });
};
DictionaryValueListHeader.displayName = 'DictionaryValueListHeader';
export { DictionaryValueListHeader };
